import { Card, CardContent, Grid, Typography } from '@mui/material';
import { apiEntities, generic } from 'apis';
import Questionnaire from 'common/Questionnaire';
import { FunctionsReverse, ProjectTables } from 'enums';
import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';

const QuestionnairePart = ({ func, arrayIndex }) => {
    const { t } = useTranslation();

    const questionnaireQuery = useQuery(['questionnaire', func?.id, func?.functionId], async ({ queryKey }) => {
        const getQuestionnaireRequest = {
            DataKey: 'FunctionId',
            DataValue: func?.functionId,
            RecordId: func?.id,
            // RecordGuid: id === '0' ? null : id,
            ProjectTableId: ProjectTables.PersonFunction
        };
        const result = await apiEntities.getData({ dataKey: 'QuestionnaireSection-Get', parameters: getQuestionnaireRequest });
        return result;
    });

    return (
        <>
            {questionnaireQuery?.data?.data ? (
                <Card elevation={3} sx={{ mb: 3 }}>
                    <CardContent>
                        <Grid item xs={12} marginTop={2} marginBottom={3}>
                            <Typography color="primary" variant="h4">
                                {t('Profile.Questionnaire', { function: FunctionsReverse?.[func?.functionId] ?? '' })}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {questionnaireQuery?.data?.data.map((qst, index) => (
                                <FunctionQuestions functionId={func?.functionId} personFunctionId={func?.id} qst={qst} key={index} />
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
            ) : null}
        </>
    );
};

const FunctionQuestions = ({ functionId, personFunctionId, qst, arrayIndex }) => {
    const form = useFormContext();
    const { fields, append, prepend, remove, swap, move, insert, replace } = useFieldArray({
        control: form.control,
        name: `questionnaires[${personFunctionId ?? functionId}]`
    });

    return (
        <Questionnaire
            flatQuestions
            data={qst}
            append={append}
            fields={fields}
            name={`questionnaires[${personFunctionId ?? functionId}]`}
            functionId={functionId}
            pfid={personFunctionId}
        />
    );
};

export default QuestionnairePart;
